import { gql } from '@apollo/client';
/**
 * @const RefundDealPaymentMutation
 * @since 1.0.0
 */
export const RefundDealPaymentMutation = gql `
  mutation RefundDealPaymentMutation($input: RefundDealPaymentInput!) {
    refundDealPayment(input: $input) {
      id
      status
      refundProvider
      refundableAmount
      refunds {
        id
        amount
        provider
        status
        reason
        error
        createdAt
      }
    }
  }
`;
